/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

import { createApp } from 'vue'
import App from './views/App.vue'
import router from './router'
import store from './store'
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
import Swal from 'sweetalert2';
import { createMetaManager } from 'vue-meta'
import LoadScript from "vue-plugin-load-script";
import FloatingVue from 'floating-vue'
//import * as Sentry from "@sentry/vue"

// Subscribe to store updates
store.subscribe((mutation, state) => {
	// Store the state object as a JSON string
	localStorage.setItem('store', JSON.stringify(state));
});

/*const app = createApp({
    extends: App,
    //beforeCreate() { this.$store.commit('initialiseStore') }
})*/

const app = createApp(App)
app.use(FloatingVue)
app.use(store)
app.use(router)
app.use(VueSweetalert2)
app.use(createMetaManager())
app.use(LoadScript)
app.provide('BASE_PATH', '/sl')

/*
let sentryDsn = SENTRY_DSN
Sentry.init({
    app,
    dsn: sentryDsn,
    integrations: [
        new Sentry.BrowserTracing({
            // Set `tracePropagationTargets` to control for which URLs distributed tracing should be enabled
            // tracePropagationTargets: ["localhost", /^https:\/\/yourserver\.io\/api/],
            routingInstrumentation: Sentry.vueRouterInstrumentation(router),
        }),
        new Sentry.Replay(),
    ],

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 0.0,

    // Capture Replay for 10% of all sessions,
    // plus for 100% of sessions with an error
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    trackComponents: true,
});
*/


app.mount('#app')
